import { Injectable } from '@angular/core';
import { Error } from '@models';
import { ErrorMessageKeysEnum } from '@modules/core/enums';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageKeyService {
  getKey(error: Error): string {
    if (error.codeName && ErrorMessageKeysEnum[error.codeName as keyof typeof ErrorMessageKeysEnum]) {
      return ErrorMessageKeysEnum[error.codeName as keyof typeof ErrorMessageKeysEnum];
    }

    return ErrorMessageKeysEnum.DEFAULT_ERROR;
  }
}
